export default __webpack_public_path__ + "static/media/gsmbd.9ab0b1e8.png";